import { getIsLoggedIn } from '@immediate_media/auth-lib';

/**
 * A hook to get whether the user is logged in or not.
 */
const useLoggedIn = () => getIsLoggedIn();

export default useLoggedIn;
